"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPid = addPid;
exports.deletePid = deletePid;
exports.get_pid = get_pid;
exports.pidPage = pidPage;
exports.save_pid = save_pid;
var _request = _interopRequireDefault(require("@/utils/request"));
// 礼金推广位列表
function pidPage(data) {
  return (0, _request.default)({
    url: "/portal/system/tlj/pidPage",
    method: "post",
    data: data
  });
}
// 添加推广位
function addPid(data) {
  return (0, _request.default)({
    url: "/portal/system/tlj/addPid",
    method: "post",
    data: data
  });
}
// 修改推广位
// export function editPid(data) {
//   return request({
//     url: '/portal/system/tlj/editPid',
//     method: 'post',
//     data
//   })
// }
// 删除推广位
function deletePid(params) {
  return (0, _request.default)({
    url: "/portal/system/tlj/deletePid",
    method: "get",
    params: params
  });
}
function save_pid(data) {
  return (0, _request.default)({
    url: "/portal/system/tlj/savePid",
    method: "post",
    data: data
  });
}
function get_pid(params) {
  return (0, _request.default)({
    url: "/portal/system/tlj/getPidConfig",
    method: "get",
    params: params
  });
}